module.exports = __webpack_public_path__ + "static/media/mainCarousel-large.e9c22f4d.png";